import React, {useState} from "react";
import {OptiselModal} from "../../components/modal/OptiselModal";
import UboldSpinner from "../../ubold-components/UboldSpinner";
import {callApiAssignUserToIssue, useAssignableUsers} from "./useIssueApi";
import {AssignableUserApiJson} from "./AssignableUserApiJson";

export function IssueAssigneeChangerModal(props: {
    issueId: string,
    currentAssigneeId: string | null,
    opened: boolean,
    onClose: () => void,
}) {
    return <OptiselModal opened={props.opened} closeable={true} header={"Wybierz opiekuna"} onClose={props.onClose}>
        {props.opened && <IssueAssigneeChangerContent
            issueId={props.issueId}
            currentAssigneeId={props.currentAssigneeId}
        />}
    </OptiselModal>;
}

function IssueAssigneeChangerContent(props: {
    issueId: string,
    currentAssigneeId: string | null,
}) {
    const {result} = useAssignableUsers();
    const [status, setStatus] = useState<"picking" | "saving">("picking");
    const [savingForUserId, setSavingForUserId] = useState<string | null>(null);

    if (result === "loading") {
        return <div className={"text-center"}><UboldSpinner/></div>;
    }

    const pickUser = (userId: string) => {
        setStatus("saving");
        setSavingForUserId(userId);
        callApiAssignUserToIssue(props.issueId, userId)
            .then(() => window.location.reload())
            .catch(err => {
                console.error("Failed to assign user to issue", err);
                setStatus("picking");
                setSavingForUserId(null);
                alert("Nie udało się zmienić opiekuna. Spróbuj ponownie.");
            });
    };

    if (result.length === 0) {
        return <div className={"text-center text-gray-600"}>Brak użytkowników do przypisania.</div>;
    }

    return <div className={"d-flex flex-column"}>
        {result.map(user => <AssignableUserRow
            key={user.id}
            user={user}
            isCurrent={user.id === props.currentAssigneeId}
            disabled={status === "saving"}
            isBeingSaved={savingForUserId === user.id}
            onPick={() => pickUser(user.id)}
        />)}
    </div>;
}

function AssignableUserRow(props: {
    user: AssignableUserApiJson,
    isCurrent: boolean,
    disabled: boolean,
    isBeingSaved: boolean,
    onPick: () => void,
}) {
    const className = props.isCurrent
        ? "btn btn-light-primary w-100 text-start mb-2"
        : "btn btn-light w-100 text-start mb-2";
    return <button
        className={className}
        disabled={props.disabled}
        onClick={props.onPick}
    >
        <div><strong>{props.user.email}</strong></div>
        <div className={"text-gray-600 fs-7"}>{props.user.name}</div>
        {props.isCurrent && <div className={"text-gray-500 fs-8"}>(obecny opiekun)</div>}
        {props.isBeingSaved && <div className={"mt-1"}><UboldSpinner/></div>}
    </button>;
}
